export const API_ROOT = (process.env.NODE_ENV === 'production') ?
  'https://api.ministerie-owcs.cw/pepms/api' :
//'http://localhost:8082/cresbo/api';
'https://api.ministerie-owcs.cw/pepms/api' ;

